export default __webpack_public_path__ + "static/media/HomeMobile.b1348646.png";